define(['angular', 'opentip'], function (angular, Opentip) {
    'use strict';

    Opentip.styles.attention = {
        background: 'white',
        borderColor: 'white',
        borderRadius: 5,
        closeButtonCrossColor: '#FFFFF',
        closeButtonCrossSize: 10,
        closeButtonOffset: [5, 5],
        closeButtonRadius: 5,
        closeButtonLinkOverscan: 20,
        escapeTitle: false,
        fixed: true,
        group: 'attention-tooltip',
        hideTrigger: 'closeButton',
        shadowColor: 'rgba(0, 0, 0, 0.5)',
        showOn: 'click',
        stemBase: 30,
        stemLength: 15,
        target: true,
        tipJoint: 'top',
        title: "<span class='attention fa fa-exclamation-triangle'></span>",
    };

    Opentip.styles.info = {
        background: '#f2f2f2',
        borderColor: '#f2f2f2',
        borderRadius: 5,
        escapeTitle: false,
        fixed: true,
        group: 'info-tooltip',
        shadowColor: 'rgba(0, 0, 0, 0.5)',
        stemBase: 10,
        stemLength: 5,
        target: true,
        tipJoint: 'top',
    };

    Opentip.styles.link = Opentip.styles.info;
    Opentip.styles.link.hideTriggers = [document, document];
    Opentip.styles.link.hideOn = 'click';

    return angular
        .module('tooltipDirectives', [])
        .directive('opentip', function () {
            return {
                restrict: 'A',
                scope: {
                    message: '=opentip',
                },
                link: function (scope, element, attrs) {
                    var options = {};
                    if (
                        attrs.hasOwnProperty('tooltipStyle') &&
                        attrs.tooltipStyle
                    ) {
                        options.style = attrs.tooltipStyle;
                    }
                    new Opentip(element, scope.message, options);
                },
            };
        });
});
